import React from "react";
import IconHolderInfo from "../../Resources/svg/Icons/IconHolderInfo";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";

const CardInfoCompany = (props: any) => {
  const client = props.client;

  return (
    <div className="cardInfo">
      <div className="cardInfo__data">
        <div className="cardInfo__data__title">
          { client.companyName }
        </div>
      </div>
      <div className="cardInfo__data__info">
        <div className="cardInfo__data__items">
          <div className="is--title">RUC</div>
          <div className="is--data">{client.nroDoc}</div>
        </div>
      </div>
      <IconHolderInfo />
    </div>
  );
};

export default CardInfoCompany;
